import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from '../../Modules/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';
import RelatedTransactionsFilters from './RelatedTransactionsFilters';
import RelatedTransactionsParser from './RelatedTransactionsParser';
import RelatedTransactionEntries from './RelatedTransactionEntries';
import RelatedTransactionPaginator from './RelatedTransactionPaginator';
import EmailPopup from './EmailPopup';
import Flash from '../docket/Flash';

import './RelatedTransaction.less';
import PublicLinkPopup from './PublicLinkPopup';
import Notification from '../../common/Notification/Notification';

class RelatedTransaction extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };
  static defaultProps = {
    onSubmit: () => null,
  };

  getClassName = index => (index % 2 === 0 ? 'even' : 'odd');
  getPartiesTableBody = (data) => {
    if (data.length === 0) {
      return (
        <div>
          <div className="ir-search-status-message messages warning">
            {this.props.noDataFoundMessage}
          </div>
        </div>
      );
    }
    const rows = data.map((item, index) => (
      <tbody>
        <tr key={index} className={`${this.getClassName(index)} heading`} >
          <td align="right" colSpan="1"><strong className="docketNumber"><span onClick={() => this.props.getDocketData(item.text.docket_no, index)}>{ item.text.docket_no || '' }</span></strong></td>
          <td />
          <td><strong>{ item.text.event_name || '' }</strong></td>
          <td>{ item.text.date_event_filed || '' }</td>
          <td>{ item.text.date_event_terminated || '' }</td>
        </tr>
        { (this.props.dockets && this.props.visibleDocketRow === `${item.text.docket_no}-${index}`) && this.subDockets(this.getClassName(index), item.text.docket_no, index) }
        { this.subTransactions(item.text.related, this.getClassName(index), index) }
      </tbody>
    ));

    return (
      <div>
        <Notification />
        <FilterTable premiumSearch={{ uuid: this.props.case_uuid, query: this.props.type }}>
          <table className="sticky-enabled tablesorter" id="ir-search-related-transactions-results">
            <thead>
              <tr>
                <th colSpan="2"><span>#</span></th>
                <th><span>Event Name</span></th>
                <th><span>Event Filed</span></th>
                <th><span>Event Terminated</span></th>
              </tr>
            </thead>
            { rows }
          </table>
        </FilterTable>
      </div>
    );
  };

  subDockets = (className, transactionDocketNumber, index) => {
    const rows = this.props.dockets.data.map((item, index) => (
      <tbody>
        <tr key={index} className={className}>
          <td />
          {item.part && <td>{ item.part}</td>}
          {item.description && <td>{ item.description}</td>}
          {item.pages && <td>{ item.pages}</td>}
          {item.actions &&
            <td>
              {item.actions.download_url && <a href={item.actions.download_url} id="download" title="Download File"><span className="download icon" /></a>}
              {item.actions.email_docket_pdf && <a onClick={() => this.props.toggleEmailPopup()} id="email" title="Email" style={{ cursor: 'pointer' }}><span className="email icon" /></a>}
              {item.actions.print_docket_pdf && <a href={item.actions.print_docket_pdf} id="print" title="Print preview"><span className="preview icon" /></a>}
              {item.actions.public_link_html && <a title="Public Download Link" onClick={() => this.props.togglePublicLinkPopup()} style={{ cursor: 'pointer' }}><span className="public link icon" /></a>}
              {item.actions.blog_post_url && <a href={item.actions.blog_post_url} title="Create blog post" target="_blank"><span className="blog-post icon" /></a>}
              {item.actions.download_ocr_uri && <a href={item.actions.download_ocr_uri} id="download-OCR" title="Download OCR"><span className="download ocr icon" /></a>}
              {item.actions.purchase_pdf_url_free && <a onClick={() => this.props.buyFromPacer(transactionDocketNumber, item.part)} className="form-submit free-download" style={{ cursor: 'pointer' }}>Free Download</a>}
              {item.actions.purchase_pdf_url_buy_alfresco && <a onClick={() => this.props.buyFromAlfresco(transactionDocketNumber, item.part)} className="form-submit orange" style={{ cursor: 'pointer' }}>Buy ${item.cost}</a>}
              {item.actions.purchase_pdf_url_buy_pacer && <a onClick={() => this.props.buyFromPacer(transactionDocketNumber, item.part)} className="form-submit green" style={{ cursor: 'pointer' }}>Buy ${item.cost}</a>}
            </td>
          }
        </tr>
        <tr className="even">
          <td colSpan="100%" align="right">
            <a onClick={() => this.props.getDocketDatafromPacer(transactionDocketNumber, index)} className="" style={{ cursor: 'pointer' }}>Refresh Part List from PACER</a>
          </td>
        </tr>
        {this.props.showEmailPopup ?
          <EmailPopup
            friendly_name={item.actions.email_docket_pdf}
            part_number={item.part}
            docketNumber={transactionDocketNumber}
            closePopup={this.props.toggleEmailPopup}
            sendDocketViaEmail={this.props.sendDocketViaEmail}
            emails={this.props.emails}
          />
            : null
          }
        {this.props.showPubliclinkPopup ?
          <PublicLinkPopup
            public_link_html={item.actions.public_link_html}
            public_pdf_link={item.actions.public_pdf_link}
            friendly_name={item.actions.email_docket_pdf}
            closePopup={this.props.togglePublicLinkPopup}
          />
              : null
            }
        {!this.props.emails.dataReady && <tr className={className}><td colSpan="5"><LoadingBar /></td></tr>}
        {this.props.emails.dataReady && this.props.emails.status && this.props.showEmailNotification && <tr className={className}><td colSpan="5"><span style={{ border: '1px solid', padding: '5px' }} ><span className="email icon" /> The filing has been emailed to {this.props.emails.email} <i onClick={this.props.closeEmailNotification} className="fa fa-times-circle" style={{ fontSize: '16px', cursor: 'pointer' }} /></span></td></tr>}
      </tbody>
    ));
    if (!this.props.dockets.dataReady) {
      return <tr className={className}><td colSpan="5"><LoadingBar /></td></tr>;
    } else if (this.props.dockets.dataReady && this.props.dockets.data.length >= 1) {
      return (
        <tr className={`${className} docket_details heading subDocket`}>
          <td colSpan="1" />
          <td className="here" colSpan="100%">
            <table className="sticky-enabled tablesorter" >
              <thead>
                <tr>
                  <th />
                  <th>Part</th>
                  <th>Description</th>
                  <th>Pages</th>
                  <th width="50%">Action</th>
                </tr>
              </thead>
              {rows}
            </table>
          </td>
        </tr>);
    }
    return (
      <tr className={`${className} docket_details heading subDocket`}>
        <td colSpan="5">No Accessible Documents Found</td>
      </tr>
    );
  };

  subTransactions = (data, className, index) => {
    const transactions = data.map((item, key) => (
      <tbody>
        <tr colSpan="5" key={key} className={`${className} subDocket`}>
           <td align="right" colSpan="2"><strong className="docketNumber"><span onClick={() => this.props.getDocketData(item.docket_no, `${key}-${key}`)}>{ item.docket_no || '' }</span></strong></td>
           <td>{ item.event_name || '' }</td>
           <td>{ item.date_event_filed || '' }</td>
           <td>{ item.date_event_terminated || '' }</td>
         </tr>
        {(this.props.dockets && this.props.visibleDocketRow === `${item.docket_no}-${index}-${key}`) && this.subDockets(className, item.docket_no, `${key}-${key}`) }
      </tbody>
    ));
    return (
      <tr className={`${className} docket_details heading subDocket`}>
          <td colSpan="1" />
          <td className="here" colSpan="4">
            {transactions}
          </td>
        </tr>);
  };

  render() {
    console.log(this.props)
    const { RelatedTransactionPopup, relatedTransactionEntriesProps, relatedTransactionPaginatorProps, tableSortProps, docketParts } = this.props;
    if (!this.props.dataReady) return <LoadingBar />;
    const alertError = this.props.error ? <AlertError errors={this.props.error} /> : null;

    const tableData = this.props.transactions || [];
    return (
      <div className={this.props.type}>
        <Flash show={docketParts.showFlash}
          msg={`The filing has been mailed to ${docketParts.email_address}`} />

        <RelatedTransactionsFilters
          onSubmit={this.props.onSubmit}
          togglePacerFilterSection={this.props.togglePacerFilterSection}
          showPacerFilterSection={this.props.showPacerFilterSection}
          />
        <RelatedTransactionsParser
          onSubmit={this.props.onSubmitParser}
          onReset={this.props.resetParser}
          showPacerFilterSection={this.props.showPacerFilterSection}
          />
        <RelatedTransactionPaginator {...relatedTransactionPaginatorProps} />
        {alertError}
        <RelatedTransactionEntries {...relatedTransactionEntriesProps} {...this.props} />
        <RelatedTransactionPaginator {...relatedTransactionPaginatorProps} />
        { RelatedTransactionPopup && <RelatedTransactionPopup
          onClose={this.props.onPopupClick}
          info={this.props.popup}
          reloadDetails={this.reloadDetails} /> }
      </div>
    );
  }
}

RelatedTransaction.defaultProps = {
  error: null,
  receipt: null,
  type: 'related_transactions',
};

RelatedTransaction.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  transactions: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  error: PropTypes.any,
  getDocketData: PropTypes.func.isRequired,
  purchaseData: PropTypes.func.isRequired,
  buyFromPacer: PropTypes.func.isRequired,
  buyFromAlfresco: PropTypes.func.isRequired,
  toggleEmailPopup: PropTypes.func.isRequired,
  togglePublicLinkPopup: PropTypes.func.isRequired,
};

export default RelatedTransaction;



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransaction.js